import { render, staticRenderFns } from "./RoundButton.vue?vue&type=template&id=74d2e9b2"
import script from "./RoundButton.vue?vue&type=script&lang=js"
export * from "./RoundButton.vue?vue&type=script&lang=js"
import style0 from "./RoundButton.vue?vue&type=style&index=0&id=74d2e9b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports